import React from "react";
import { Newspaper } from "../../assets";
import { locales } from "../../locales";
import { excelDateToJSDate } from "../../utils/communesUtils";

const Article = ({ langId, data, isCommuneArticle, index }) => {
  const handleClick = (url) => {
    window.open(url + "?utm_source=election-module");
  };
  const isOdd = index % 2 === 0;
  return (
    <div
      className={`flex flex-col pt-3 pl-1 border-b-2 border-black-opacity-20 hover:border-black hover:bg-wort-background ${
        isOdd ? "wort-medium:mr-10" : ""
      }`}
      style={{ minWidth: 320, height: 100 }}
    >
      <div className="flex flex-row items-center mb-2">
        <span className="mr-2 text-xs opacity-60 leading-[14.4px]">
          {excelDateToJSDate(data.date)}
        </span>
        <span className="text-sm text-primary font-semibold uppercase leading-[16.8px]">
          {isCommuneArticle
            ? locales[langId].articleForCommune
            : locales[langId].article}
        </span>
      </div>
      <div
        className="flex flex-row justify-between pr-2 wort-medium:justify-between cursor-pointer"
        onClick={() => handleClick(data.url)}
      >
        <div className="h-12">
          <p className="mr-4  wort-medium:text-lg wort-medium:leading-[24px]">
            {data.title}
          </p>
        </div>
        <div className="w-[50px] flex justify-end">
          <Newspaper />
        </div>
      </div>
    </div>
  );
};

export default Article;
